import CONSTANTS from "../constants";

export function pushToGTMTracker(trackIdentifier, pageTitle) {
	switch (trackIdentifier) {
		case "homepageWithoutMap-page":
			window.dataLayer.push({
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/dealer-locator/searchwomap",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': window.siteConfig['currentCountry'],
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "dealer locator page",
			});

			break;
		case "homepageWithMap-page":
			window.dataLayer.push({
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/dealer-locator/search",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': window.siteConfig['currentCountry'],
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "dealer locator page",
			});

			break;
		case "listing-page":
			window.dataLayer.push({
				'event': 'updatevirtualpath',
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/dealer-locator/appointment-schedule-search",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': window.siteConfig['currentCountry'],
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "dealer locator page",
			});

			break;
		case "soloDealer-page":
			window.dataLayer.push({
				'event': 'updatevirtualpath',
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/dealer-locator/solo-dealer",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': window.siteConfig['currentCountry'],
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "dealer locator page",
			});

			break;
		case "RefererSoloDealer-page":
			window.dataLayer.push({
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/dealer-locator/solo-dealer",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': window.siteConfig['currentCountry'],
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "dealer locator page",
			});

			break;
		case "car-details-page":
			window.dataLayer.push({
				'event': 'updatevirtualpath',
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/car-details",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': window.siteConfig['currentCountry'],
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "dealer locator page",
				'formsName': "appointment request",
				'mainStepIndicator': "1",
				'mainStepName': "car details"
			});

			break;

		case "services-page":
			window.dataLayer.push({
				'event': 'updatevirtualpath',
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/services",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': window.siteConfig['currentCountry'],
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "dealer locator page",
				'formsName': "appointment request",
				'mainStepIndicator': "2",
				'mainStepName': "services"
			});

			break;

		case "personal-page":
			window.dataLayer.push({
				'event': 'updatevirtualpath',
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/personal-data",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': window.siteConfig['currentCountry'],
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "dealer locator page",
				'formsName': "appointment request",
				'mainStepIndicator': "3",
				'mainStepName': "personal informations"
			});

			break;

		case "summary-page":
			window.dataLayer.push({
				'event': 'updatevirtualpath',
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/summary",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': window.siteConfig['currentCountry'],
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "dealer locator page",
				'formsName': "appointment request",
				'mainStepIndicator': "4",
				'mainStepName': "summary"
			});

			break;

		case "confirmation-page":
			window.dataLayer.push({
				'event': 'updatevirtualpath',
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/confirm",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': window.siteConfig['currentCountry'],
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "dealer locator page",
				'formsLeadType': "cold lead",
				'formsPostalCode': "{{formsPostalCode}}",
				'formsName': "appointment request",
				'mainStepIndicator': "5",
				'mainStepName': "confirmation"
			});

			break;

		case "edit-page":
			window.dataLayer.push({
				'event': 'updatevirtualpath',
				'brand': window.siteConfig['brandGTM'],
				'virtualPageURL': "/edit",
				'pageName': window.siteConfig['pageName'] + '/' + pageTitle,
				'language': window.siteConfig['language'],
				'country': window.siteConfig['currentCountry'],
				'siteTypeLevel1': window.siteConfig['siteTypeLevel1'],
				'siteTypeLevel2': "appointement",
				'siteOwner': "central",
				'siteTarget': "B2C",
				'siteFamily': "after-sales",
				'pageCategory': "dealer locator page",
				'formsName': "appointment request",
				'mainStepName': "edit"
			});

			break;
		default:
			console.error('this tracker "' + trackIdentifier + '" is not identified , please contact the administrator!');
			break;
	}

}
export function pushEventToGTM(content) {
	window.dataLayer.push({
		'pageName': content.pageName,
		'event': 'uaevent',
		'eventCategory': 'Content',
		'eventAction': content.eventAction,
		'eventLabel': content.eventLabel
	});
}
